
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import {Component} from "react";
import {connect} from "react-redux";
import {SwarmDataMixin, getSwarmDataKeyForRequest} from "../../../mixins/swarmDataMixin";
import {getSwarmSubscriptionRequestSportListStandart} from "../../../helpers/terminalRequests/sportsList";
import {getSportListSubscriptionRequest} from "../../../../dev/helpers/asianHelpers/requests";
import {createSelector} from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import PropTypes from "prop-types";
import moment from "moment";
import { HideBetslip } from "../../../actions/terminal";
import Config from "../../../config/main";

let ctx;

function mouseUpHandler () {
    clearTimeout(this.timerScroll);
    this.clickedSportsList = true;
    this.delta = 0;
    document.removeEventListener("mouseup", mouseUpHandler);
}

class SportsList extends Component {
    handleMouseUp () {
        document.addEventListener("mouseup", mouseUpHandler.bind(this));
    }
    scroll (scroller, scrollSize, delay) {
        let iterator = scrollSize > 0 ? 0.1 : -0.1;
        this.delta = this.delta || iterator;
        this.delta += iterator;
        this.clickedSportsList = false;
        scroller.scrollLeft += (scrollSize + this.delta);
        this.timerScroll = setTimeout(() => {
            !this.clickedSportsList && this.scroll(scroller, scrollSize, delay);
        }, delay);
    }

    render () {
        ctx = this.context;
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

SportsList.propTypes = {
    sportAlias: PropTypes.any,
    gameType: PropTypes.string,
    isAsian: PropTypes.bool,
    loaded: PropTypes.bool,
    firstSportAlias: PropTypes.string,
    sportsCount: PropTypes.number,
    selectorKey: PropTypes.string,
    location: PropTypes.object
};

SportsList.contextTypes = {
    router: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownParams) => {
    let {gameType, timeFilter, today, isAsian, isForHashing = false} = ownParams;
    let key = getSwarmDataKeyForRequest(isAsian ? getSportListSubscriptionRequest(gameType, timeFilter, isForHashing, today) : getSwarmSubscriptionRequestSportListStandart(gameType, timeFilter, ownParams.videoFilter, isForHashing));
    return createSelector(
        [
            state => state.swarmData.data[key],
            state => state.swarmData.loaded[key],
            state => state.terminal.boostedOddsGameIds
        ],
        (data, loaded, boostedOddsGameIds) => {
            let sportsCount, firstSportAlias;
            if (data && data.length > 0 && loaded) {
                sportsCount = data.length;
                firstSportAlias = gameType === "topGames" ? "all/all" : data[0].alias;
                firstSportAlias = gameType === "esports" ? `${firstSportAlias}/all` : firstSportAlias;
            } else if (data && data.length === 0) {
                sportsCount = 0;
            }
            return {
                sportsCount,
                loaded,
                firstSportAlias,
                selectorKey: key,
                boostedOddsGameIds
            };
        });
};
export default connect(mapStateToProps)(SwarmDataMixin({
    Component: SportsList,
    ComponentWillMount: function () {
        let {gameType, timeFilter, today, isAsian, isForHashing = false} = this.props;
        this.swarmSubscriptionRequest = isAsian ? getSportListSubscriptionRequest(gameType, timeFilter, isForHashing, today) : getSwarmSubscriptionRequestSportListStandart(gameType, timeFilter, this.props.videoFilter, isForHashing);
        this.swarmDataKey = getSwarmDataKeyForRequest(isAsian ? getSportListSubscriptionRequest(gameType, timeFilter, isForHashing, today) : getSwarmSubscriptionRequestSportListStandart(gameType, timeFilter, this.props.videoFilter, isForHashing));
        this.meta = {
            simplify: true,
            parseToArray: true,
            sortingFunction: Helpers.byOrderSortingFunc,
            objectToArray: Helpers.objectToArray,
            payloadKey: "sport"
        };
    },
    ComponentWillReceiveProps: function (nextProps) {
        // select first sport if no sport is selected
        if (nextProps.timeFilter !== this.props.timeFilter) {
            let {gameType, timeFilter, today, isAsian, isForHashing = false} = nextProps;
            this.swarmSubscriptionRequest = isAsian ? getSportListSubscriptionRequest(gameType, timeFilter, isForHashing, today) : getSwarmSubscriptionRequestSportListStandart(gameType, timeFilter, this.props.videoFilter, isForHashing);
            // const { timeFilter } = nextProps
            // const gte = Config.enableOneDayRangeFilterPrematch ? (timeFilter - 24) * 3600 : 0;

            // if (timeFilter === 0) {
            //     this.swarmSubscriptionRequest.where.game["@or"] = [
            //         {
            //             "type": {"@in": [0, 2]}
            //         }
            //     ];
            // } else {
            //     // this.swarmSubscriptionRequest.where.game["@or"] = [
            //     //     {
            //     //         "start_ts": {
            //     //             '@now': {
            //     //                 '@gte': Config.enableDayFormatInPrematchLeftMenu
            //     //                     ? moment().startOf("day").unix() + (timeFilter * 2)
            //     //                     : gte,
            //     //                 '@lt': Config.enableDayFormatInPrematchLeftMenu ? moment().endOf("day").unix() + timeFilter : timeFilter * 3600
            //     //             }
            //     //         },
            //     //         "type": {"@in": [0, 2]}
            //     //     }
            //     // ];
            // }

            this.resubscribe(true);
        }
        else if (!nextProps.sportAlias && nextProps.firstSportAlias) {

            if (nextProps.sportAlias === "boosted" && nextProps.gameType === "prematch" && Config.enableBoostedOdds) {
                return ctx.router.replace(`/${nextProps.gameType}/${nextProps.sportAlias}/all`);
            }
            if (ctx && nextProps.location.pathname.indexOf(nextProps.firstSportAlias) === -1 && !nextProps.location.pathname.includes("boosted")) {

                return ctx.router.replace(nextProps.location.pathname + "/" + nextProps.firstSportAlias);
            }
        } else if (nextProps.sportsCount === 0 && nextProps.gameType === "today" && this.time <= 2) {

            this.swarmSubscriptionRequest.where.game["@or"] = [
                {
                    "start_ts": {
                        '@gte': moment().add(this.time, 'days').startOf("day").unix(),
                        '@lte': moment().add(this.time, 'days').endOf("day").unix()
                    },
                    "type": {"@in": [0, 2]}
                }
            ];
            this.time++;
            this.resubscribe(true);
        } else if (!nextProps.sportsCount) {
            nextProps.dispatch(HideBetslip(true));
        } else nextProps.dispatch(HideBetslip(false));
    }
}));
